import { __ } from '@wordpress/i18n';
import { useState, useEffect } from '@wordpress/element';

const OverviewTab = ({ onSetTab, stats, refreshStats }) => {
    const [isScanning, setIsScanning] = useState(false);
    const [progress, setProgress] = useState(0);

    const handleStartScan = async () => {
        setIsScanning(true);
        setProgress(0);
        
        let offset = 0;
        let complete = false;

        while (!complete) {
            try {
                const response = await fetch(window.mtrimAdminData.ajaxUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    body: new URLSearchParams({
                        action: 'mtrim_start_scan',
                        nonce: window.mtrimAdminData.nonce,
                        offset: offset
                    })
                });

                const data = await response.json();

                if (data.success) {
                    const result = data.data;
                    offset = result.next_offset;
                    const percent = Math.round((offset / result.total) * 100);
                    setProgress(percent);
                    
                    if (result.is_complete) {
                        complete = true;
                    }
                } else {
                    console.error('Scan failed:', data.data.message);
                    break;
                }
            } catch (error) {
                console.error('Scan error:', error);
                break;
            }
        }

        setIsScanning(false);
        if (complete) {
            // Refresh stats
            refreshStats();
            // Move to results
            onSetTab('mtrim-unused');
        }
    };

    return (
        <div className="mtrim-overview-tab">
            <div className="mtrim-welcome-banner">
                <div className="mtrim-welcome-content">
                    <h1>{__('Smart Media Cleanup', 'media-trim')}</h1>
                    <p>{__('Scan, Detect & Safely Remove Unused and Duplicate Files from your WordPress library.', 'media-trim')}</p>
                </div>
                <div className="mtrim-welcome-stats">
                    <div className="mtrim-welcome-stat">
                        <span className="value">{stats.total}</span>
                        <span className="label">{__('Total Files', 'media-trim')}</span>
                    </div>
                </div>
            </div>

            <div className="mtrim-stats-grid">
                <div className="mtrim-stat-card primary">
                    <div className="mtrim-stat-icon">
                        <span className="dashicons dashicons-admin-media"></span>
                    </div>
                    <div className="mtrim-stat-content">
                        <h3>{__('Total Media', 'media-trim')}</h3>
                        <div className="mtrim-stat-value">{stats.total}</div>
                        <p>{__('Files in your library', 'media-trim')}</p>
                    </div>
                </div>

                <div className="mtrim-stat-card warning">
                    <div className="mtrim-stat-icon">
                        <span className="dashicons dashicons-trash"></span>
                    </div>
                    <div className="mtrim-stat-content">
                        <h3>{__('Potential Unused', 'media-trim')}</h3>
                        <div className="mtrim-stat-value">{stats.unused || '--'}</div>
                        <p>{__('Files detected as unused', 'media-trim')}</p>
                    </div>
                </div>

                <div className="mtrim-stat-card danger">
                    <div className="mtrim-stat-icon">
                        <span className="dashicons dashicons-images-alt2"></span>
                    </div>
                    <div className="mtrim-stat-content">
                        <h3>{__('Duplicates Found', 'media-trim')}</h3>
                        <div className="mtrim-stat-value">{stats.duplicates || '--'}</div>
                        <p>{__('Identical image files', 'media-trim')}</p>
                    </div>
                </div>
            </div>

            <div className="mtrim-scan-container">
                {isScanning && <div className="mtrim-scanning-effect"></div>}
                <div className="mtrim-scan-header">
                    <h2>{__('System Scan', 'media-trim')}</h2>
                    <p>{__('Check your media library for unused, orphaned, or duplicate files.', 'media-trim')}</p>
                </div>

                {isScanning ? (
                    <div className="mtrim-progress-box">
                        <div className="mtrim-progress-bar-wrapper">
                            <div className="mtrim-progress-bar" style={{ width: `${progress}%` }}></div>
                        </div>
                        <div className="mtrim-progress-details">
                            <span>{__('Scanning media library...', 'media-trim')}</span>
                            <span>{progress}%</span>
                        </div>
                    </div>
                ) : (
                    <div className="mtrim-start-box">
                        <button className="mtrim-start-btn" onClick={handleStartScan}>
                            <span className="dashicons dashicons-search"></span>
                            {__('Start Full Scan', 'media-trim')}
                        </button>
                    </div>
                )}

                <div className="mtrim-scan-options">
                    <label>
                        <input type="checkbox" checked readOnly />
                        {__('Standard Scan (Posts, Pages, Featured Images)', 'media-trim')}
                    </label>
                    <label>
                        <input type="checkbox" checked readOnly />
                        {__('Duplicate Detection (MD5 Binary Hash)', 'media-trim')}
                    </label>
                </div>
            </div>
        </div>
    );
};

export default OverviewTab;
